module.exports = __webpack_public_path__ + "img/16@3x.6396817c.png";